import makeStyles from '@mui/styles/makeStyles';
import MatchSummaries from "components/Matching/MatchSummaries";
import {Search} from "lucide-react";
import {filter, get, isNumber} from "lodash";
import React from "react";
import {useTranslation} from "react-i18next";
import GroupHoldArt from "components/Illustrations/GroupHoldArt";
import {color, font, match, radius, type} from "common/tokens";

const useStyles = makeStyles({
  art: {
    display: 'block',
    width: 360,
    maxWidth: '100%',
    margin: '24px auto 28px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  slot: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    background: match.SLOT_BG,
    borderRadius: radius.MEDIA_CARD,
    padding: 16,
  },
  slotIcon: {
    width: 30,
    height: 30,
    flexShrink: 0,
    borderRadius: '50%',
    background: color.SURFACE,
    color: color.TEXT_MUTED,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  slotTitle: {
    ...type.sessionTitle,
    color: color.TEXT,
  },
  slotSub: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    marginTop: 4,
  },
});

const GroupHold = ({groupInfo}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const groupMembers = filter(get(groupInfo, 'existingMemberInfo'), member => isNumber(get(member, 'id')));
  const openSpots = Math.max(get(groupInfo, 'groupSize', 0) - get(groupInfo, 'actualSize', 0), 0);

  return (
    <div>
      <GroupHoldArt className={classes.art}/>
      <div className={classes.column}>
        <MatchSummaries matches={groupMembers} infoOnly showExpiryDuration={false}/>
        {openSpots > 0 && (
          <div className={classes.slot}>
            <span className={classes.slotIcon}><Search size={14} strokeWidth={2.5}/></span>
            <div>
              <div className={classes.slotTitle}>{t('availableSpotForMentee', {count: openSpots})}</div>
              <div className={classes.slotSub}>{t('findingMatchesEllipsis')}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupHold;
